var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 14,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4119 21.3743V20.1543C11.4119 19.6477 11.5319 19.1943 11.7719 18.7943C12.0119 18.3943 12.3319 18.0743 12.7319 17.8343C13.1453 17.5943 13.5919 17.4743 14.0719 17.4743H19.0719C19.1653 17.4743 19.2453 17.441 19.3119 17.3743C19.3919 17.2943 19.4319 17.2077 19.4319 17.1143V13.6943C19.4319 13.5877 19.3919 13.501 19.3119 13.4343C19.2453 13.3543 19.1653 13.3143 19.0719 13.3143H9.23194V10.9143H19.1319C19.6253 10.9143 20.0719 11.041 20.4719 11.2943C20.8853 11.5343 21.2119 11.8543 21.4519 12.2543C21.7053 12.6543 21.8319 13.1077 21.8319 13.6143V17.1943C21.8319 17.6743 21.7053 18.121 21.4519 18.5343C21.2119 18.9343 20.8853 19.261 20.4719 19.5143C20.0719 19.7543 19.6253 19.8743 19.1319 19.8743H14.1719C14.0786 19.8743 13.9919 19.9143 13.9119 19.9943C13.8453 20.061 13.8119 20.141 13.8119 20.2343V21.3743H11.4119ZM11.4119 25.3143V22.9343H13.8119V25.3143H11.4119Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.bfa96d2f80ae052aca70e35552a7cbce.svg";
export { ForwardRef as ReactComponent };